import React from "react";
import withLocalization from "../../../hoc/with-localization";
const PrmTablePatientFIO = props => {
    const {
        name: { name, patronymic, surname },
        sex,
        loc
    } = props;
    const sSex = sex === "M" ? ` (${loc("report.patient.sex.M")})` : sex === "F" ? ` (${loc("report.patient.sex.F")})` : "",
        sPatName = `${surname} ${name} ${patronymic}${sSex}`;
    return (
        <table className="prm-table prm-table-patient-FIO">
            <tbody>
                <tr>
                    <td className="prm-title prm-title-invert">{loc("report.patient.FIO")}</td>
                    {/* <td className="prm-gap"></td> */}
                    <td className="prm-data prm-data-invert">{sPatName}</td>
                </tr>
            </tbody>
        </table>
    );
};

export default withLocalization(PrmTablePatientFIO);
